export default "__VITE_ASSET__BqVzRhFv__"